<template>
  <div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>บัญชีแสดงสัญญา </label><span class="required">*</span>
        <b-form-input @keypress="isNumber($event)"
          v-model="caNo"
          name="caNo2"
          type="text"
          :class="{'input': true, 'is-danger': errors.has('caNo2') }"
          maxlength="12"
        ></b-form-input>
      </div>
      <div class="form-group col-md-6">
        <label>เลขที่คำขอเงินประกัน</label><span class="required">*</span>
        <input  @keypress="isNumber($event)"
          v-model="securityNo"
          name="securityNo2"
          type="text"
          class="form-control"
          :class="{'input': true, 'is-danger': errors.has('securityNo2') }"
          maxlength="10"
        >
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label>หมายเลขคู่ค้าทางธุรกิจ</label><span class="required">*</span>
        <input  @keypress="isNumber($event)"
          v-model="bpNo"
          name="bpNo2"
          type="text"
          class="form-control"
          :class="{'input': true, 'is-danger': errors.has('bpNo2') }"
          maxlength="10"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  props: ["appVo","reqType"],
  data() {
    return {
      caNo: this.appVo.caNo,
      securityNo: this.appVo.securityNo,
      bpNo: this.appVo.bpNo,
    };
  },

   mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.caNo = this.appVo.caNo;
      this.securityNo = this.appVo.securityNo;
      this.bpNo = this.appVo.bpNo;

      this.$emit("childExtToParent", {
          caNo: this.caNo,
          securityNo: this.securityNo,
          bpNo: this.bpNo,
        });
    }
  },  
  
  watch: {
    caNo(newVal, oldVal) {

      this.$emit("childExtToParent", {

        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo,
      });
    },
    securityNo(newVal, oldVal) {
      this.$emit("childExtToParent", {
        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo,
      });
    },
    bpNo(newVal, oldVal) {
      this.$emit("childExtToParent", {
        caNo: this.caNo,
        securityNo: this.securityNo,
        bpNo: this.bpNo,
      });
    },
  },
  methods: {
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
  }
};
</script>